import { inject, observer } from 'mobx-react';

import type { DraftStore } from 'bz-draft';
import type DraftRenderedControlProps from 'bz-draft/modules/draft/entities/control/proptypes';
import type React from 'react';
import type { ScoresGoalsSettingsResponse } from 'tm3-core/api.dtos';
import type { ClinicalBaseControlProps } from '../clinical-base-control';
import Formula from '../formula';

export interface IProps extends ClinicalBaseControlProps, DraftRenderedControlProps {
  draftStore?: DraftStore;
  scoreGoalLink?: ScoresGoalsSettingsResponse;
  value: any;
}
export interface IState {
  value: any;
}

const DraftFormula = inject('draftStore')(
  observer<React.FC<IProps>>(({ draftStore, value, formula, onChange }) => {
    return (
      <Formula
        formulaVariables={draftStore!.formulaVariables}
        value={value}
        formula={formula}
        onChange={onChange}
      />
    );
  })
);

DraftFormula.wrappedComponent.displayName = 'DraftFormula';

export default DraftFormula;
